import React from 'react'
import InfluencerSteps from '@/Component/Auth/Register/InfluencersSteps'

const InfluencerStepsPage = () => {
  return (
    <InfluencerSteps />
  )
}

export default InfluencerStepsPage
